<!--
 * @Author: Eric hongyong.yang@nttdata.com
 * @Date: 2023-04-12 10:44:54
 * @LastEditors: Eric hongyong.yang@nttdata.com
 * @LastEditTime: 2023-04-24 18:13:04
 * @FilePath: \edp-web\src\views\360webview.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="web-view">
    <edp-header
      class="bf"
      :headerLeftWord="$t('member.360Header')"
    ></edp-header>
    <iframe v-if="sessionId" class="web-wrap" :src="urls"></iframe>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      urls: "",
      sessionId: "",
    };
  },
  computed: {
    ...mapState({
      userInfoMap: (state) => state.login.userInfo,
    }),
  },

  mounted() {
    console.log(this.utils.getCookie("edpsession"), this.userInfoMap.sessionId);
    let sstUs = setInterval(() => {
      console.log(this.userInfoMap.sessionId);
      if (this.userInfoMap && this.userInfoMap.sessionId) {
        this.sessionId = this.userInfoMap.sessionId;
        this.urls = `${process.env.VUE_APP_360URL}?sessionid=${this.sessionId}&target=home`;
        clearInterval(sstUs);
      }
    }, 100);
  },
};
</script>
<style lang="scss">
.web-view {
  width: 100%;
  height: 90vh;
  .web-wrap {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
